<template>
    <div class="container-fluid bg-light bg-gradient pt-10" style="height: 100vh;">
        <div class="container bg-white lead text-dark p-5">
            <h2>Häng kvar, du skickas nu vidare till {{ document.data.title }}...</h2>
        </div>
    </div>
</template>
<script>
export default {
    async asyncData({$prismic, route, error}) {
        const err = { statusCode: 404, message: 'Not found' };

        try {
            const document = await $prismic.api.getByID(route.params.id);

            if (typeof document === 'undefined' || document.data.redirect_enabled === false) {
                return error(err);
            }

            return {
                document
            };
        }
        catch (e) {
            error(err);
        }
    },
    head() {
        return {
            title: 'Du skickas nu vidare...',
            meta: [
                { name: 'robots', content: 'noindex' }
            ]
        };
    },

    mounted() {
        window.location.assign(this.$tracking.addTrackingParameters(this.document.data.redirect));
    }
};
</script>